import { useQuery } from '@tanstack/react-query';
import { http } from '@lib/api';
import { queryKeys } from '@lib/queryKeys';
import type { components } from '@/types/api.generated';

export type DispatchRouteEtaReport = components['schemas']['DispatchRouteEtaReport'];

/**
 * Today's live Onfleet ETAs for every task on each driver's route (#1128).
 * Refreshed every 60s (the backend KV cache), only while the tab is focused.
 * The desktop page and the phone view (#2487) share this one query key.
 * `http.get` unwraps the envelope to the report directly. Read-only.
 */
export function useRouteEta(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.dispatch.eta(),
    queryFn: () => http.get<DispatchRouteEtaReport>('/api/dispatch/eta'),
    enabled,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  });
}
